<template>
  <div class="box3-page">
    <div class="fcp-title">为什么建议你现在认证</div>
    <div class="fcp-text">不念过往，不负当下才能不畏将来，现在即出发！</div>
    <div class="list-mask">
      <ul>
        <li 
          v-for="(item, index) in list" 
          :key="index"
          :style="{backgroundImage: `url(${require('../../../assets/coursePage/fcp/box3/card-bg-0' + (index + 1) + '.png')})`}"
        >
          <h2>{{ item.title }}</h2>
          <div class="info-cont">
            <p v-html="item.info"></p>
            <img :src="require(`../../../assets/coursePage/fcp/box3/icon-0${index + 1}.png`)" alt="">
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        list:[
          {
            title: '已有8.4万人认证',
            info: '自2014年推出认证后，帆软已有 8.4<br/>万人通过，获证用户已在 2.6 万家企<br/>业中真正应用。',
          },
          {
            title: '符合当前招聘需求',
            info: '很多招聘单位明确要求通过帆软认证，<br/>这不但可以为求职赋能，还为自身提<br/>供更多可能性。',
          },
          {
            title: '迎合市场行情',
            info: '在当前各行业人才济济、市场行情又<br/>不太乐观的情况下，多一个傍身技能<br/>就意味着多一条可选择的道路。',
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
.box3-page{
  background-image: url(../../../assets/coursePage/fcp/box3/box3-bg.png);
  background-size: cover;
  padding: 80px 0 88px;
  .list-mask{
    width: 100%;
    margin-top: 48px;
    overflow-x: auto;
    overflow-y: hidden;
    height: 284px;
    ul{
      max-width: 1888px;
      height: 324px;
      display: flex;
      padding: 0 32px 40px;
      overflow-x: auto;
      overflow-y: hidden;
      box-sizing: border-box;
      li{
        min-width: 608px;
        width: 608px;
        height: 284px;
        padding: 40px;
        margin-right: 32px;
        box-sizing: border-box;
        background-size: 100% 100%;
        box-shadow: 0px 4px 16px 0px rgba(90,192,255,0.16);
        border-radius: 8px;
        h2{
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #24375C;
          line-height: 48px;
        }
        .info-cont{
          margin-top: 24px;
          display: flex;
          justify-content: space-between;
          p{
            flex: 1;
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #425A7C;
            line-height: 44px;
            white-space: nowrap;
          }
          img{
            margin-top: 8px;
            min-width: 80px;
            width: 80px;
            height: 80px;
          }
        }
        &:last-child{
          margin: 0;
        }
      }
    }
  }
}
</style>